<template>
  <v-container fluid grid-list-lg>    
    <v-layout wrap >
      <template v-if="!modoSimple">
        <v-flex v-for="domicilio in domicilios" v-bind:key="domicilio.orden" lg4 sm6 xs12>
            <app-domicilio-completo :value="domicilio" :provincias="provincias" ref="hijos" 
              :permitirEliminar="permitirEliminar" :setPredeterminado="setPredeterminado"></app-domicilio-completo>
        </v-flex>
        
        <v-flex align-self-center >
          <v-tooltip bottom v-if="permitirAgregar">
            <template v-slot:activator="{ on }">
              <v-btn fab small  color="green lighten-1" dark v-on="on" @click="addChild"><v-icon>add</v-icon></v-btn>
            </template>
            <span>Agregar nuevo Domicilio</span>  
          </v-tooltip>
        </v-flex>
      </template>
    </v-layout>

    <v-layout wrap >
      <template v-if="modoSimple">
        <v-flex v-for="domicilio in domicilios" v-bind:key="domicilio.orden" >
            <app-domicilio-completo :value="domicilio" :provincias="provincias" ref="hijos" 
              :permitirEliminar="permitirEliminar" :setPredeterminado="setPredeterminado"></app-domicilio-completo>
        </v-flex>
        
        <v-flex align-self-center >
          <v-tooltip bottom v-if="permitirAgregar">
            <template v-slot:activator="{ on }">
              <v-btn fab small  color="green lighten-1" dark v-on="on" @click="addChild"><v-icon>add</v-icon></v-btn>
            </template>
            <span>Agregar nuevo Domicilio</span>  
          </v-tooltip>
        </v-flex>
      </template>
    </v-layout>
  </v-container>  
</template>

<script>

import Vue from 'vue'

import { http } from '@/axios'

export default {
   data: () => ({    
    loading: false,
    provincias: [],
    domicilios: []
  }),
  props: {
    value: {
      type: Object,
      required: false
    },
    propName:{
        type: String,
        required: false,
        default: 'domicilios'
    },
    label: {
      type: String,
      default: 'Domicilios'
    },
    iconName: {
      type: String,
      default: 'home'
    },
    modoSimple: {
        type: Boolean,
        default: false
      },
    permitirAgregar: {
        type: Boolean,
        default: false
    },
    permitirEliminar: {
        type: Boolean,
        default: false
    },
  },
  watch:{
      'value.domicilios': function(item){          
        this.setDomicilios()
      }
  },
   created () {    
    // cargolas provincias
    this.loadProvincias();
    // cargo el modelo
    this.setDomicilios()
  },
  methods: {      
      setDomicilios(){
        if(!this.value[this.propName]){ // Si el domicilio no está cargado, creo la propiedad 
            this.domicilios = [{
                calle: '',
                numero: '',
                piso: '',
                departamento: '',
                entreCalle1: '',
                entreCalle2: '',
                barrio: '',
                localidad: '',
                codigoPostal: '',
                partido: '',
                provincia: '',
                orden: 1
            }]
            
            this.value[this.propName] = this.domicilios
        }
        this.domicilios = this.value[this.propName]
      },
      setPredeterminado(domicilio){
        // quito la marca de predeterminado de los otros domicilios (si hay)          
        for (let index = 0; index < this.domicilios.length; index++) {

          if(this.domicilios[index].orden != domicilio.orden){
            this.domicilios[index].esPrincipal = false;
            this.$refs.hijos.find(ref=>ref.domicilio.orden == this.domicilios[index].orden).esPrincipal = false;
          }
        }

        // marco el actual como predeterminado
        domicilio.esPrincipal = true;
      },
      async addChild(){

        const res = await this.$dialog.confirm({
          text: '¿Está seguro que quiere agregar un domicilio?',
          title: 'Confirmar Operación',
          persistent: true // Parece que no funciona...
        })

        if (!res) {
          return;
        }
        
        var ultimoOrden = 0; // Busco el último orden que hay
        for (let index = 0; index < this.domicilios.length; index++) {
          ultimoOrden = this.domicilios[index].orden;
        }

        //todo: al agregar domicilio, traer datos predeterminados (por ejemplo la provincia en base a la sucursal, la localidad, etc)
        var nuevoDomicilio = {
          calle: '',
                numero: '',
                piso: '',
                departamento: '',
                entreCalle1: '',
                entreCalle2: '',
                barrio: '',
                localidad: '',
                codigoPostal: '',
                partido: '',
                provincia: '',
                orden: ultimoOrden + 1
        }

        if(this.domicilios.length > 0){
          // si ya hay algún otro domicilio, copio la provincia/partido, localidad y CP
          nuevoDomicilio.provincia = this.domicilios[0].provincia;
          nuevoDomicilio.partido = this.domicilios[0].partido;
          nuevoDomicilio.localidad = this.domicilios[0].localidad;
          nuevoDomicilio.codigoPostal = this.domicilios[0].codigoPostal;
        }
        else{
          nuevoDomicilio.esPrincipal = true;
        }
        
        this.domicilios.push(nuevoDomicilio);
          
        Vue.nextTick(() => { // esto es para esperar a que se renderice el componente nuevo
          this.$refs.hijos.find(ref=>ref.domicilio.orden == nuevoDomicilio.orden).editModeOn = true;
        }); 
      },
      async deleteChild(domicilioAEliminar){
        const res = await this.$dialog.confirm({
          text: '¿Confirma la eliminación del Domicilio?',
          title: 'Confirmar Operación',
          persistent: true // Parece que no funciona...
        })

        if (res) {
          var indiceAEliminar = -1;
          for (let index = 0; index < this.domicilios.length; index++) {
            if(this.domicilios[index].orden == domicilioAEliminar.orden){
              indiceAEliminar = index;
              break;
            }
          }

          //Vue.$log.debug(indiceAEliminar);

          if(indiceAEliminar >=0){
            this.domicilios.splice(indiceAEliminar,1);
          }
        }
      },
      async loadProvincias(){
        this.loading = true
        try {
            var result = await http.get('provincias'); // traigo todas
            this.provincias = result.list;            
        } catch (error) {
            // Error
            Vue.$log.error(error);
        }
        this.loading = false
      },
  }
}
</script>

<style>

</style>
